import icons from "../../img/icon/icons";
import { iconColor, iconSize } from "./Common";
/**
 * @interface
 * @prop {string} name 이름 {@link icons}
 * @prop {string} size (optional) 사이즈 {@link iconSize}
 * @prop {string} color (optional) 색상 {@link iconColor}
 * @prop {string} cursor (optional) 커서 모양
 */
interface IconProps {
    name: string;
    size?: string;
    size2?: string;
    color?: string;
    cursor?: string;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * 공통 아이콘 컴포넌트
 * @author mjkang
 * @since 2024-08-23 09:34:01
 * @param props {@link IconProps}
 * @returns Icon
 */
const Icon = (props: IconProps) => {
    const size = props.size && iconSize[props.size] ? iconSize[props.size] : iconSize.default;
    const size2 = props.size2 && iconSize[props.size2] ? iconSize[props.size2] : iconSize.default;
    const color = props.color && iconColor[props.color] ? iconColor[props.color] : props.color;
    const url = icons[props.name];

    const style = {
        width: size,
        height: size,
        cursor: props.cursor,
        filter: color,
    };

    const iconStyle = {
        width: size,
        height: !props.size2 ? size : size2,
        cursor: props.cursor,
        WebkitMaskImage: `url('${url}')`,
        maskImage: `url('${url}')`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center center",
        WebkitMaskPosition: "center center",
        maskSize: "100%",
        WebkitMaskSize: "100%",
        backgroundColor: color ?? "var(--main-color)",
    };
    
    const wrapper = {
        width: "fit-content",
        height: "fit-content",
    };

    return (
        <>
            {url && url.endsWith("svg") ? (
                <div style={ {...wrapper, ...props.style }} draggable="false" className={props.className}>
                    <div style={iconStyle}></div>
                </div>
            ) : (
                <img
                    src={icons[props.name]}
                    alt={props.name}
                    style={{ ...style, ...props.style }}
                    className={props.className}
                    draggable="false"
                />
            )}
        </>
    );
};

export default Icon;
